import React, { useCallback } from 'react';

import { addMessage } from '@/features';
import { useAppDispatch, useAppSelector } from '@/store';

import { TextOption } from '../ChatMessage/VisitorOptions/FieldOptions/TextOption';

import { st, classes } from './SuggestedQuestionsPayload.st.css';

export const SuggestedQuestionsPayload = ({ title }: { title?: string }) => {
  const dispatch = useAppDispatch();
  const isAwaitingAnswer = useAppSelector(
    (state) => state.messages.awaitingAnswer,
  );

  const onSubmit = useCallback(() => {
    if (title?.trim().length && !isAwaitingAnswer) {
      dispatch(addMessage({ body: { mainText: title } }));
    }
  }, [dispatch, isAwaitingAnswer, title]);

  if (!title) {
    return null;
  }

  return (
    <TextOption
      className={st(classes.root)}
      text={title}
      onClick={onSubmit}
      disabled={isAwaitingAnswer}
    />
  );
};
